'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

exports.default = (0, _lodash.curry)(function (combiningFn, obj1, obj2) {
    return (0, _lodash.mapValues)(obj2, function (val1, property) {
        return combiningFn(val1, obj1[property]);
    });
}); // Lib


//////////////////
// WEBPACK FOOTER
// ./src/common/utils/lib/combine.js
// module id = 2292
// module chunks = 0